import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { toast } from "react-toastify";
import {
  FRAUD_ALERTS_KEY,
  propertyShieldApi,
  type FraudAlertsParams
} from "api/propertyShield";
import { useAuthContext } from "providers/Auth";
import { getErrorMessage } from "utils/error";

/** Disabled until Property Shield is connected: the endpoint 403s. */
export const useFraudAlertsController = (
  params: FraudAlertsParams,
  { enabled = true }: { enabled?: boolean } = {}
) => {
  const { type } = useAuthContext();

  const query = useQuery({
    queryKey: [FRAUD_ALERTS_KEY, params],
    queryFn: () => propertyShieldApi.getFraudAlerts(params),
    enabled: type.isListingFraudAlerts && enabled,
    placeholderData: keepPreviousData,
    meta: { onError: (error: unknown) => toast.error(getErrorMessage(error)) }
  });

  const perPage = params.per_page ?? 20;
  const total = query.data?.total ?? 0;

  return {
    alerts: query.data?.items ?? [],
    total,
    pageCount: Math.ceil(total / perPage),
    isLoading: query.isLoading,
    isFetching: query.isFetching
  };
};
